/* ==========================================================================
   PADENUS - MAIN THEME JAVASCRIPT & THEME EDITOR LIFECYCLE
   ========================================================================== */

function initAllComponents() {
  initFaqAccordions();
  initStickyAtcBar();
  initMobileMenu();
  initUgcPlayers();
}

document.addEventListener('DOMContentLoaded', initAllComponents);

/* Theme Editor Event Listeners */
document.addEventListener('shopify:section:load', (event) => {
  initAllComponents();
});

document.addEventListener('shopify:section:unload', (event) => {
  // Cleanup if necessary
});

document.addEventListener('shopify:block:select', (event) => {
  const block = event.target;
  if (block && block.classList.contains('faq-item')) {
    block.classList.add('active');
  }
});

/* FAQ Accordion */
function initFaqAccordions() {
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const trigger = item.querySelector('.faq-trigger');
    if (!trigger || trigger.dataset.initialized) return;
    trigger.dataset.initialized = 'true';
    trigger.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');
      // Close other accordion items in the same container
      const container = item.closest('.faq-container') || item.closest('.pdp-accordions') || document;
      container.querySelectorAll('.faq-item').forEach(other => {
        other.classList.remove('active');
        other.querySelector('.faq-trigger')?.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('active');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* Sticky Add to Cart Bar */
function initStickyAtcBar() {
  const stickyBar = document.getElementById('StickyAtcBar');
  const mainBuyBtn = document.querySelector('.main-product-atc-btn');

  if (!stickyBar || !mainBuyBtn || stickyBar.dataset.initialized) return;
  stickyBar.dataset.initialized = 'true';

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
  }, { threshold: 0.1 });

  observer.observe(mainBuyBtn);
}

/* Mobile Menu Navigation */
function initMobileMenu() {
  const menuTrigger = document.querySelector('[data-mobile-menu-trigger]');
  const mobileNav = document.getElementById('MobileNavDrawer');
  const closeBtn = document.querySelector('[data-mobile-nav-close]');
  const backdrop = document.querySelector('[data-mobile-nav-backdrop]');

  if (!menuTrigger || !mobileNav || menuTrigger.dataset.initialized) return;
  menuTrigger.dataset.initialized = 'true';

  const openMenu = () => {
    mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  menuTrigger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);

  // Accordion toggle in mobile menu
  const accordions = mobileNav.querySelectorAll('.mobile-nav-item--accordion');
  accordions.forEach(item => {
    const toggle = item.querySelector('.mobile-nav-toggle');
    const sublist = item.querySelector('.mobile-nav-sublist');
    if (toggle && sublist && !toggle.dataset.initialized) {
      toggle.dataset.initialized = 'true';
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = sublist.style.display === 'none';
        sublist.style.display = isOpen ? 'flex' : 'none';
        const svg = toggle.querySelector('svg');
        if (svg) svg.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
      });
    }
  });
}

/* UGC Play / Pause */
function initUgcPlayers() {
  document.querySelectorAll('[data-ugc-play-toggle]').forEach((button) => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = 'true';

    const card = button.closest('[data-ugc-card]');
    if (!card) return;

    const video = card.querySelector('video');
    const iframe = card.querySelector('iframe');
    const provider = card.dataset.ugcProvider;

    const updateState = (isPlaying) => {
      card.classList.toggle('is-playing', isPlaying);
      button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      button.setAttribute('aria-label', isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel);
    };

    const sendPlayerCommand = (command) => {
      if (!iframe?.contentWindow) return;

      if (provider === 'youtube') {
        iframe.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func: command === 'play' ? 'playVideo' : 'pauseVideo',
          args: [],
        }), '*');
      } else if (provider === 'vimeo') {
        iframe.contentWindow.postMessage({ method: command }, '*');
      }
    };

    const pause = () => {
      if (video && !video.paused) video.pause();
      if (iframe) sendPlayerCommand('pause');
      updateState(false);
    };

    card.ugcPause = pause;

    button.addEventListener('click', async () => {
      const isPlaying = button.getAttribute('aria-pressed') === 'true';

      document.querySelectorAll('[data-ugc-card].is-playing').forEach((otherCard) => {
        if (otherCard !== card && typeof otherCard.ugcPause === 'function') otherCard.ugcPause();
      });

      if (isPlaying) {
        pause();
        return;
      }

      if (video) {
        try {
          video.muted = false;
          await video.play();
        } catch (error) {
          updateState(false);
        }
      } else {
        sendPlayerCommand('play');
        updateState(true);
      }
    });

    if (video) {
      video.addEventListener('play', () => updateState(true));
      video.addEventListener('pause', () => updateState(false));
      video.addEventListener('ended', () => updateState(false));
    }
  });
}
